import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import navSections from "./navSections";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  collapseShow = "hidden";
  moduleActive: string;

  navSections = navSections;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.moduleActive = this.route.snapshot.routeConfig.path;
  }
  toggleCollapseShow(classes) {
    this.collapseShow = classes;
  }

  isActiveClass(isActive: boolean): string {
    return isActive
      ? "text-indigo-600 hover:text-indigo-700"
      : "text-blueGray-700 hover:text-blueGray-500";
  }
}
